import type { ReactNode } from 'react';
import { useMemo, useState } from 'react';

import { getFromLocalStorage } from '@/utils/localStorage';

import { REGION_SEASON_STORAGE_KEY } from './constants';
import { RegionSeasonContext } from './context';
import type { RegionSeason } from './types';

const RegionSeasonProvider = ({ children }: { children: ReactNode }) => {
  const [value, setValue] = useState(
    getFromLocalStorage<RegionSeason>(REGION_SEASON_STORAGE_KEY)
  );

  const contextValue = useMemo(
    () => ({
      value,
      setValue: (newValue?: RegionSeason) => {
        if (!newValue) {
          localStorage.removeItem(REGION_SEASON_STORAGE_KEY);
          setValue(undefined);
          return;
        }
        localStorage.setItem(
          REGION_SEASON_STORAGE_KEY,
          JSON.stringify(newValue)
        );
        setValue(newValue);
      }
    }),
    [value]
  );

  return (
    <RegionSeasonContext.Provider value={contextValue}>
      {children}
    </RegionSeasonContext.Provider>
  );
};

export default RegionSeasonProvider;
